const PAYMENT_PROGRESS = {
  section: {
    name: 'payment-progress'
  },
  sectionFields: [
    {
      paid: { label: 'Paid Principal', template: '{principal}', fieldKey: 'principal', format: 'currency' },
      left: { label: 'Left Principal', template: '{principal}', fieldKey: 'principal', format: 'currency' }
    },
    {
      paid: { label: 'Paid Finance Charge', template: '{interest}', fieldKey: 'interest', format: 'currency' },
      left: { label: 'Left Finance Charge', template: '{interest}', fieldKey: 'interest', format: 'currency' }
    },
    {
      paid: { label: 'Paid Unpaid Finance', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' },
      left: { label: 'Left Unpaid Finance', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' }
    },
    {
      divider: true,
      paid: { label: 'Total Paid', template: '{amount}', fieldKey: 'amount', format: 'currency' },
      left: { label: 'Total Left', template: '{amount}', fieldKey: 'amount', format: 'currency' }
    }
  ]
}
export default PAYMENT_PROGRESS
